






























import Vue from 'vue'
import EnharmonicSelector from '@/components/EnharmonicSelector.vue'

export default Vue.extend({
  components: {
    EnharmonicSelector
  },
  data() {
    return {
      showMenu: false
    }
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
    }
  }
})
